
const Refresh = () => {
    return setTimeout(() => {
        window.location.reload();
    }, 500); 
}   
export default Refresh; 